/**
 * Normaliza a saudação de aceite (`greetingAcceptedMessage`).
 *
 * Existe porque os três pontos que aceitam ticket montavam o corpo com
 * `${setting.greetingAcceptedMessage}`. Isso tem dois problemas: interpolar
 * `null` produz a string literal `"null"` — que o backend aceita e envia ao
 * cliente — e string vazia vira `body: ""`, que o backend recusa com 400 e o
 * atendente vê como erro ao aceitar.
 *
 * Retorna sempre uma string. Vazia significa "não há saudação configurada",
 * e nesse caso o chamador não deve enviar nada.
 */
export const normalizeGreetingAcceptedMessage = setting => {
  const value = setting?.greetingAcceptedMessage;

  // Só string interessa: null, undefined, número ou objeto não são saudação.
  if (typeof value !== "string") return "";

  return value.trim();
};

export default normalizeGreetingAcceptedMessage;
